class ThumbnailsCarousel extends HTMLElement {
  constructor() {
    super()

    this.$nextEl = this.querySelector('.thumbnails-carousel--icon-next')
    this.$prevEl = this.querySelector('.thumbnails-carousel--icon-previous')

    this.galleryCarousel = document.querySelector('.js-gallery-carousel')

    this.changeActiveSlide = this.changeActiveSlide.bind(this)
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-thumbnails-carousel')
    const option = {
      init: false,
      spaceBetween: 5,
      slidesPerView: 6,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 5,
      slidesOffsetBefore: 5,
      slideToClickedSlide: true,
      navigation: {
        nextEl: this.$nextEl,
        prevEl: this.$prevEl,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
        1024: {
          slidesPerView: 5.78,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      },
    }

    this.$swiper = new Swiper(swiperEl, option)

    this.$swiper.on('click', (swiper, event) => {
      swiper.slides.forEach(el => {
        el.classList.remove('swiper-slide-active')
      })
      swiper.clickedSlide.classList.add('swiper-slide-active')
      this.galleryCarousel.goToSlide(swiper.clickedIndex)
    })

    this.$swiper.on('slideChange', (swiper) => {
      this.galleryCarousel.goToSlide(swiper.activeIndex)
    })

    this.$swiper.init()
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }

  changeActiveSlide(index) {
    this.$swiper.slideTo(index)
    this.$swiper.slides.forEach((el, i) => {
      el.classList[index === i ? 'add': 'remove']('swiper-slide-active')
    })
  }
}

customElements.define('thumbnails-carousel', ThumbnailsCarousel)
